// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.feedback {
  display: flex;
  flex-direction: column;
  width: min(700px, 92vw);
  max-height: 80vh;
  padding: 20px 24px;
  box-sizing: border-box;
}
div.feedback h2 {
  color: #444;
  margin: 0 0 12px 0;
  font-size: clamp(18px, 2.5vw, 24px);
}
div.feedback textarea {
  resize: vertical;
  min-height: 180px;
  max-height: 50vh;
  margin-bottom: 10px;
  padding: 10px;
  font-size: 16px;
  line-height: 1.6;
  background-color: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.2);
  overflow: auto;
  box-sizing: border-box;
}
div.feedback div.actions {
  align-self: flex-end;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
div.feedback div.actions button.send {
  margin-right: 0;
}

@media (max-width: 600px) {
  div.feedback {
    width: 94vw;
    padding: 16px;
    max-height: 82vh;
  }
  div.feedback textarea {
    min-height: 140px;
    max-height: 45vh;
  }
  div.feedback div.actions {
    align-self: stretch;
  }
  div.feedback div.actions button {
    flex: 1 1 auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/feedback/feedback.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AADJ;AAGI;EACI,WCXI;EDYJ,kBAAA;EACA,mCAAA;AADR;AAII;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,qCCnBW;EDoBX,oCAAA;EACA,cAAA;EACA,sBAAA;AAFR;AAKI;EACI,oBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AAHR;AAKQ;EACI,eAAA;AAHZ;;AAQA;EACI;IACI,WAAA;IACA,aAAA;IACA,gBAAA;EALN;EAOM;IACI,iBAAA;IACA,gBAAA;EALV;EAQM;IACI,mBAAA;EANV;EAQU;IACI,cAAA;EANd;AACF","sourcesContent":["@use 'colors' as *;\n\ndiv.feedback {\n    display: flex;\n    flex-direction: column;\n    width: min(700px, 92vw);\n    max-height: 80vh;\n    padding: 20px 24px;\n    box-sizing: border-box;\n\n    h2 {\n        color: $text-dark;\n        margin: 0 0 12px 0;\n        font-size: clamp(18px, 2.5vw, 24px);\n    }\n\n    textarea {\n        resize: vertical;\n        min-height: 180px;\n        max-height: 50vh;\n        margin-bottom: 10px;\n        padding: 10px;\n        font-size: 16px;\n        line-height: 1.6;\n        background-color: $dates-background;\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        overflow: auto;\n        box-sizing: border-box;\n    }\n\n    div.actions {\n        align-self: flex-end;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 8px;\n\n        button.send {\n            margin-right: 0;\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    div.feedback {\n        width: 94vw;\n        padding: 16px;\n        max-height: 82vh;\n\n        textarea {\n            min-height: 140px;\n            max-height: 45vh;\n        }\n\n        div.actions {\n            align-self: stretch;\n\n            button {\n                flex: 1 1 auto;\n            }\n        }\n    }\n}\n","$text-dark: #444;\n\n$dark-gray: rgba(0,0,0,0.6);\n$light-gray: rgba(0,0,0,0.10);\n\n$dates-background: rgba(0,0,0,0.05);\n\n// cornelsen colors\n$cv-red: rgb(222,41,34);\n$cv-grass-dark: rgb(107,171,45);\n$cv-grass-medium: rgb(177,198,16);\n$cv-grass-light: rgb(220,235,205);\n$cv-sky-dark: rgb(0,148,170);\n$cv-sky-medium: rgb(109,186,210);\n$cv-sky-light: rgb(210,235,235);\n$cv-sand-dark: rgb(175,157,140);\n$cv-sand-medium: rgb(212,202,189);\n$cv-sand-light: rgb(240,230,225);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
